import { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { api, errorMessage } from "../lib/api";

export const OutcomeSettings = ({ session, onBack }) => {
  const [options, setOptions] = useState([]);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/outcomes").then(({ data }) => setOptions(data.options)).catch((e) => setError(errorMessage(e))); }, []);
  const save = async (event) => {
    event.preventDefault(); setBusy(true); setSaved(false); setError("");
    try {
      const { data } = await api.put("/outcomes", { options }, { headers: { "X-CSRF-Token": session.csrf_token } });
      setOptions(data.options); setSaved(true);
    } catch (e) { setError(errorMessage(e)); }
    finally { setBusy(false); }
  };
  return <form className="outcome-settings" onSubmit={save} data-testid="outcome-settings-form">
    <button type="button" className="sheet-back" onClick={onBack} data-testid="outcomes-back-button">‹ Profilo</button>
    <h2 className="sheet-title" data-testid="outcomes-title">ESITI INCONTRO</h2>
    {options.map((item, index) => <div className="form-field" key={item.code}><label htmlFor={`outcome-label-${item.code}`}>ESITO {index + 1}</label><input id={`outcome-label-${item.code}`} value={item.label} minLength={2} maxLength={60} required onChange={(event) => setOptions(options.map((option) => option.code === item.code ? { ...option, label: event.target.value } : option))} data-testid={`outcome-label-${item.code}`} /></div>)}
    {error && <p className="form-error" role="alert" data-testid="outcomes-error">{error}</p>}
    {saved && <p className="venue-success" role="status" data-testid="outcomes-saved">Esiti aggiornati.</p>}
    <Button type="submit" className="hud-button" disabled={busy || !options.length} data-testid="outcomes-save-button">{busy ? "Salvataggio…" : "Salva esiti"}</Button>
  </form>;
};